import React from "react";

function AboutUs() {
  return (
    <div className="container">
      <div className="page-head">
        <span>अध्यक्ष का संदेश</span>
      </div>

      <p className="drop-case">
        प्रिय निवासियों, हम सभी जानते हैं कि पानी जीवन का आधार है। इसके बिना न
        तो प्रकृति जीवित रह सकती है, न ही हमारा समाज। आज के समय में बढ़ती
        जनसंख्या और जलस्रोतों के दोहन के कारण पानी की कमी एक गंभीर समस्या बनती
        जा रही है।
      </p>
      <p className="tabbed-paragraph">
        हम सभी का यह दायित्व है कि हम अपने घरों और समाज में पानी की बचत करें।
        कृपया निम्न बातों का ध्यान रखें:
      </p>
      <ol>
        <li>नलों को खुला न छोड़ें — इस्तेमाल के बाद हमेशा बंद करें।</li>
        <li>
          कार, बगीचे या फर्श की सफाई में पाइप के बजाय बाल्टी और मग का प्रयोग
          करें।
        </li>
        <li>
          वर्षा के पानी को बचाने के लिए रेनवॉटर हार्वेस्टिंग सिस्टम को सक्रिय
          रखें।
        </li>
        <li>
          टंकियों में पानी ओवरफ्लो न हो, इसके लिए फ्लोट वाल्व या अलार्म लगवाएँ।
        </li>
        <li>बच्चों को भी कम उम्र से पानी की कीमत समझाएँ।</li>
      </ol>
      <p className="tabbed-paragraph">
        याद रखें, आज की बचत, कल की सुरक्षा है। “एक-एक बूँद हमारी आने वाली पीढ़ी
        की अमानत है।”
      </p>
      <p className="tabbed-paragraph">
        आइए, हम सब मिलकर अपने समाज को एक जल-संवेदनशील और पर्यावरण मित्र समाज
        बनाएं।
      </p>
      <p style={{textAlign:"right"}} >सादर,
        <br />
        रतन सिंह यादव (अध्यक्ष)
        <br />
        रेजिडेंट वेलफेयर सोसाइटी (OCRWS-PH-1)
      </p>
    </div>
  );
}

export default AboutUs;
